export const FLEX_REQUEST_FORM_DEFAULT_VALUES = {
  reason: null,
  date: null,
  costCenter: null,
  rosterFunction: null,
  dutyType: null,
  preferences: [],
  qualifications: [],
  notes: null
};
